import uuid from 'uuid/v4'
import fetch from '@jarvis.oddle/core/tools/fetch'
import { API_ROOT, origin } from 'config/client'
import { getListOfVouchersPath, validateVoucherPath } from './server'

const call = async (target, payload = true, options = { credentials: 'include' }) => {
  const json = (await fetch(target, options, true)) || {}

  // Process return data.
  if (payload) {
    if (typeof payload === 'function') {
      return payload(json)
    } else {
      return json.payload
    }
  } else {
    return json
  }
}

const makeOptions = ({ payload, method = 'GET', include = true, req }) => {
  return ({
    credentials: include ? 'include' : '',
    method,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Cookie': req && req.get('Cookie'),
      'X-Request-Id': uuid()
    },
    body: JSON.stringify(payload)
  })
}

export const getListOfVouchersApi = ({ req, customer, order }) => call(
  `${origin(req)}${API_ROOT}${getListOfVouchersPath}`,
  (json) => json.data,
  makeOptions({
    method: 'POST',
    payload: { customer, order }
  })
)

export const validateVoucherApi = ({ req, customer, order, code }) => call(
  `${origin(req)}${API_ROOT}${validateVoucherPath(code)}`,
  (json) => json.data,
  makeOptions({
    method: 'POST',
    payload: { customer, order }
  })
)
